import {Button, styled} from "@mui/material"

/**
 * A MUI styled component that gets rid of an annoying console error.
 *
 * The discreteOpen button is an extension of the 'text' Button variant. Its style is defined inside theme.js.
 */
const DiscreteOpenButton = styled(Button)(({theme}) => ({
	position: "absolute",
	bottom: 0,
	right: 0,
	margin: "0 10px 2px 0",
	textTransform: "none",
	padding: "1px 50px",
	transition: "background-color color 250ms ease-in",
	"&:hover": {
		backgroundColor: theme.palette.primary.transparency20,
		color: theme.palette.alertRed.mainTransparency100,
	},
	color: theme.palette.alertRed.main,
}))

export default DiscreteOpenButton
